import React, { useCallback, useContext, useMemo } from "react";
import { Box, Button, ButtonGroup, Dialog, DialogContent, InputAdornment, Paper, Popover, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import ModAccName from 'components/ModAccName';
import { DialogFooter, DialogHeader } from 'components/dialog/DialogHeader';
import { numberFormat, validate } from "utils";
import PaperComponent from "components/PaperComponent";
import CheckboxFormControl from "components/CheckboxFormControl";
import useSubcontractExpenseDialog from "./useSubcontractExpenseDialog";
// import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { BoxFC, BoxFR } from "components/BoxCustom";
// import DateTimeSelect from "components/DateTimeSelect";
import { subcontractExpenseApiNm, subcontractInvoiceColNm, subcontractJobColNm } from "constants/subcontractConstant";
import ComboBox from "components/ComboBox";
import { expenseColumns, jobOrderColumns } from "./columns";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import AddButton from "components/buttons/AddButton";
import ArchiveIcon from '@mui/icons-material/Archive';
import ExpenseJobOrderDialog from "components/ExpenseJobOrderDialog";
import { DesktopDatePicker } from '@mui/x-date-pickers';
import '@mui/lab';
// import ClearButton from "components/buttons/ClearButton";
import { grey } from "@mui/material/colors";
import { ArticleRounded, LinkRounded, SearchRounded, ViewListRounded } from "resource/muiImport";
import AddExpenseTableDialog from "../AddJobOrderExpense/AddExpenseTableDialog";
import InvoiceSearchDialog from "./InvoiceSearchDialog";
import ExpenseMappingDialog from "./ExpenseMappingDialog";
import ButtonDropDown from "components/BoxCustom/ButtonDropDown";
import SearchSubcontractExpenseDialog from "./SearchSubcontractExpenseDialog";
import { originBottomCenter, originTopCenter } from "constants/popoverConstant";
import ReceiptPaper from "components/ReceiptPaper";
import FileUpload from "components/FileUplaod/FileUpload";
import { UserContext } from "contexts/UserContext";
import { ACC_TYP_EMP } from "constants/accountConstant";


const SubcontractExpenseDialog = ({ dialogOpen, setDialogOpen, selectedId, onFinish }) => {
  const { user } = useContext(UserContext)
  const { state, fn } = useSubcontractExpenseDialog({ dialogOpen, onFinish, selectedId })
  const { msData, filterData, jobOrderTable, expenseTable, jobOrdIds, selectedJOData
    , selectionModel, dialogExpOpen, selectedExpId, scInvData, fileUploadData, dialogAddExpenseTableOpen
    , dialogInvoiceSearchOpen, dialogMappingOpen, mappingData, dialogSearchOpen
    , isShowExpInInvoice, isGroupExp, anchorEl, popOverOpen, selectedRow, networkXpssDocNum, oData } = state

  const validation = useMemo(() => ({
    ScInvNo: scInvData.ScInvNo === "",
    // XpssDocNum: scInvData.XpssDocNum === "",
    ScInvDte: scInvData.ScInvDte === null,
    // XpssDocDte: scInvData.XpssDocDte === null,
  }), [scInvData]);

  const comboProp = useCallback((name, label, options) => ({
    options: options,
    label: label,
    sx: { width: 150 },
    selectedId: filterData[name],
    setSelectedId: (id) => fn.setFilterData(oldState => ({ ...oldState, [name]: id || null }))
  }), [filterData, fn])

  const datePickerProp = useCallback((name) => ({
    label: subcontractInvoiceColNm[name],
    inputFormat: "DD/MM/YYYY",
    mask: "__/__/____",
    value: scInvData[name],
    onChange: (newValue) => { fn.setScInvData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) => <TextField {...params} size="small" sx={{ flex: 1 }} error={validation[name]} required />,
  }), [fn, scInvData, validation]);

  // const invDteProp = useMemo(() => ({
  //   label: "วันที่ใบแจ้งหนี้",
  //   inputFormat: "DD/MM/YYYY",
  //   mask: "__/__/____",
  //   value: scInvData.ScInvDte,
  //   onChange: (newValue) => { fn.setScInvData(o => ({ ...o, ScInvDte: newValue })) },
  //   renderInput: (params) => <TextField {...params} size="small" sx={{ flex: 1 }} error={validation.ScInvDte} required />,
  // }), [scInvData.ScInvDte, validation.ScInvDte, fn])


  const invDataProp = useCallback((name, isNumber) => ({
    disabled: selectedId ? true : false,
    sx:{ width: 200 },
    size: "small",
    varaint: "outlined",
    required: name === "ScInvNo",
    label: !isNumber && subcontractInvoiceColNm[name],
    inputProps: isNumber && { style: { textAlign: 'right' } },
    InputProps: isNumber && { endAdornment: <InputAdornment position="end">บาท</InputAdornment> },
    value: isNumber ? numberFormat(scInvData[name]) : scInvData[name],
    onChange: (e) => isNumber ? null : fn.setScInvData(o => ({ ...o, [name]: e.target.value }))
  }), [scInvData, fn, selectedId])


  const expenseColumnsMemo = useMemo(() => expenseColumns(selectedId === 0 && fn.handleDeleteExpenseRow, msData.whtTypeCombo, fn.handlePrintWht, msData.supplierCombo)
    , [fn, selectedId, msData.whtTypeCombo, msData.supplierCombo])
  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="false"
      PaperProps={{
        style: {
          minHeight: '90%',
          maxHeight: '90%',
        }
      }}>
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ค่าใช้จ่าย Invoice รถร่วม"
        onDeleteClick={selectedId > 0 ? () => fn.deleteSubcontractInvoice() : null}
      />
      <DialogContent sx={{ display: "flex", gap: 2 }}>
        <BoxFC gap={1} flex={1}  >
          {
            selectedId === 0 &&
            <BoxFR >
              <BoxFR position="relative">


                {/* <Button variant="contained" size="small" onClick={fn.handleOpenDialogTextField}><LinkRounded sx={{ mr: 1 }} />ดึงข้อมูลจากรถร่วม</Button> */}

                {/* <DateTimeSelect
                  sx={{ width: 180 }}
                  label="วันที่นัดเข้าโรงงาน"
                  start={filterData.AptTmSt}
                  end={filterData.AptTmEn}
                  setSelectDate={(start, end) => { fn.setFilterData(o => ({ ...o, AptTmSt: start, AptTmEn: end })) }}
                />
                <TextField {...filterProp("JobOrdId")} type="number" />
                <TextField {...filterProp("ContNo")} />
                <TextField {...filterProp("JobNo")} />
                <TextField {...filterProp("Bkg")} />
                <TextField {...filterProp("Loc")} />

                <CheckboxFormControl sx={{ position: "absolute", top: 45, right: 215 }} label="เฉพาะงานรถร่วมรับผิดชอบ"
                  checked={filterData.IsOnlyScJobOrder === 1 ? true : false}
                  onChange={(e) => fn.setFilterData(o => ({ ...o, IsOnlyScJobOrder: e.target.checked ? 1 : 0 }))} />
                <CheckboxFormControl sx={{ position: "absolute", top: 45, right: 0 }} label="เฉพาะงานไม่มีใบแจ้งหนี้"
                  checked={filterData.IsNoScInvId === 1 ? true : false}
                  onChange={(e) => fn.setFilterData(o => ({ ...o, IsNoScInvId: e.target.checked ? 1 : 0 }))} /> */}
              </BoxFR>
              {/* <Button variant="contained" sx={{ minWidth: 0 }} onClick={fn.searchJobOrder}><AddCircleOutlineRoundedIcon /></Button>
              <ClearButton onClick={fn.handleClearFilter} /> */}
            </BoxFR>
          }

          <BoxFR sx={{ width: "100%" }}>
            <Typography variant="h6">ข้อมูลใบงาน</Typography>
            {
              selectedId === 0 &&
              <BoxFR flex={1}>

                {user.AccTypId === ACC_TYP_EMP ?
                  <ButtonDropDown size="small" arrowSize="small"
                    onButtonClick={fn.handleOpenDialogInvoiceSearch} buttonIcon={<LinkRounded sx={{ mr: 1 }} />}
                    buttonText="ดึงข้อมูลจากรถร่วม" >
                    <Button variant='outlined' onClick={fn.handleShowLinkExpense} >
                      <ArticleRounded sx={{ mr: 1 }} />ดูรายการค่าใช้จ่ายที่ Link กัน</Button>
                  </ButtonDropDown>
                  : null}
                {user.AccTypId === ACC_TYP_EMP ?
                  <ComboBox {...comboProp("ScId", subcontractJobColNm.ScId, msData.subContractCombo)} />
                  : null
                }
                <Box flex={1} />
                <Button variant="contained" size="small" onClick={fn.handleOpenSearchDialog}><SearchRounded sx={{ mr: 1 }} />ค้นหาและเพิ่มในตาราง</Button>
                <Button variant="contained" size="small" color="secondary" onClick={fn.handleClearJobOrdTable}>Clear ตามราง</Button>
              </BoxFR>
            }
          </BoxFR>
          <Box width="100%" mt={-1} flex={1}  >
            <DataGridCellExpand
              checkboxSelection
              selectionModel={selectionModel}
              disableSelectionOnClick
              onSelectionModelChange={fn.handleSelectionModelChange}
              onRowClick={(params) => fn.handleSelectionModelChange([params.id])}
              hideFooter
              rows={jobOrderTable}
              columns={jobOrderColumns}
              onCellClick={fn.handleCellClick} />
          </Box>
          <BoxFR>
            <Typography variant="h6">ค่าใช้จ่าย</Typography>
            {
              selectedId === 0 &&
              <BoxFR>
                <ButtonGroup>
                  <AddButton onClick={fn.handleAddExpnse} disabled={selectionModel.length === 0} size="small" >
                    เพิ่มค่าใช้จ่าย {selectionModel.length > 1 && `(${selectionModel.length} ใบงาน)`}
                  </AddButton>
                  <Button variant="contained" size="small" disabled={selectionModel.length === 0}
                    onClick={fn.handleOpenAddExpTableDialog}><ViewListRounded /></Button>
                </ButtonGroup>
                <Button variant="contained" size="small"
                  startIcon={<ArchiveIcon />}
                  onClick={fn.getSubcontractExpenseJobData}
                  disabled={selectionModel.length === 0}>
                  เพิ่มค่าขนส่งจากที่บันทึกไว้ {selectionModel.length > 1 && `(${selectionModel.length} ใบงาน)`}
                </Button>
                {user.AccTypId === ACC_TYP_EMP ?
                  <ComboBox sx={{ width: 165 }} options={msData.subContractCombo} label={subcontractJobColNm.ScId}
                    selectedId={scInvData.ScId}
                    setSelectedId={(id) => fn.setScInvData(o => ({ ...o, ScId: id }))}
                  />
                  : null
                }
              </BoxFR>
            }
            <Box flex={1} />
            <ToggleButtonGroup size="small" exclusive value={isGroupExp}
              onChange={(e, v) => { if (v !== null) fn.setIsGroupExp(v) }}>
              <ToggleButton value={true} sx={{ px: 1.25, fontSize: 12, fontWeight: 700, textTransform: "none" }}>
                รวมรายการ
              </ToggleButton>
              <ToggleButton value={false} sx={{ px: 1.25, fontSize: 12, fontWeight: 700, textTransform: "none" }}>
                แยกรายการ
              </ToggleButton>
            </ToggleButtonGroup>
            <CheckboxFormControl label="แสดงเฉพาะรายการใน Invoice นี้"
              checked={isShowExpInInvoice}
              onChange={(e) => fn.setIsShowExpInInvoice(e.target.checked)} />
            
          </BoxFR>
          {/* <Typography variant="h6">ข้อมูลรายได้</Typography> */}
          <Box width="100%" mt={-1} flex={1} sx={{
            "& .has-inv": { bgcolor: grey[200] }
          }}>
            <DataGridCellExpand
              hideFooter
              rows={expenseTable}
              columns={expenseColumnsMemo}
              columnVisibilityModel={{ JobOrdId: !isGroupExp, DocNo: !isGroupExp, DocDte: !isGroupExp }}
              isCellEditable={({ row }) => row.ScInvIds.length === 0}
              onCellEditCommit={fn.handleExpenseCellEditCommit}
              // Double-click on an editable cell starts inline edit, elsewhere it opens the dialog
              onCellDoubleClick={(params) => !params.isEditable && fn.openExpDialog(params.row.ScExpId)}
              getRowClassName={({ row }) => row.ScInvId ? "has-inv" : null} />
          </Box>
        </BoxFC>
        <Paper elevation={3} sx={{ mt: 1, width: 450, py: 1, px: 2, minHeight: 760 }}>
          <BoxFC sx={{ height: "100%", gap: 1 }}>
            <Typography variant="h6">Invoice รถร่วม</Typography>
            {user.AccTypId === ACC_TYP_EMP ?
              <BoxFR>
                <ComboBox sx={{ width: 165 }} options={msData.subContractCombo} label={subcontractJobColNm.ScId}
                  selectedId={scInvData.ScId}
                  setSelectedId={(id) => fn.setScInvData(o => ({ ...o, ScId: id }))}
                  required={true}
                  disabled={selectedId ? true : false}
                />
                <Box flex={1} />
                <CheckboxFormControl label="ลง Express แล้ว" checked={scInvData.IsXpss === 1 ? true : false}
                  onChange={fn.handleChangeIsXpss} />
              </BoxFR>
              : null}
            <BoxFR >
              <TextField {...invDataProp("ScInvNo")} sx={{ width: 165 }}
                error={validation.ScInvNo}
              />
              <DesktopDatePicker {...datePickerProp("ScInvDte")}
                disabled={selectedId ? true : false} />
            </BoxFR>
            {user.AccTypId === ACC_TYP_EMP ?
              <BoxFR>
                <TextField {...invDataProp("XpssDocNum")} sx={{ width: 165 }}
                  error={validation.XpssDocNum}
                  disabled={selectedId && oData?.XpssDocNum ? true : false} />
                {(selectedId === 0 || !networkXpssDocNum) &&
                  <Button variant="contained" onClick={fn.generateXpssDocNum}>Gen</Button>
                }

                <DesktopDatePicker {...datePickerProp("XpssDocDte")}
                  disabled={selectedId && oData?.XpssDocDte ? true : false} />

              </BoxFR>
              : null
            }
            <BoxFR>
              <TextField {...invDataProp("Rmk")} sx={{ flex: 1 }}
                disabled={ false} />
              {
                // selectedId > 0 &&
                // <Button variant="contained" size="small" onClick={fn.updateRemark}>แก้ไขหมายเหตุ</Button>
              }
            </BoxFR>
            <CheckboxFormControl label="ลงข้อมูลจบในใบงานทั้งหมด" checked={scInvData.IsSetFinDte === 1 ? true : false}
              onChange={(e) => fn.setScInvData(o => ({ ...o, IsSetFinDte: e.target.checked ? 1 : 0 }))} />
            <BoxFR justifyContent="space-between">
              <Typography>ยอดรวมใบเสร็จบริษัท</Typography>
              <TextField {...invDataProp("OwnRcptAmnt", true)} />
            </BoxFR>
            <BoxFR justifyContent="space-between">
              <Typography>ยอดรวมใบเสร็จลูกค้า</Typography>
              <TextField {...invDataProp("CusRcptAmnt", true)} />
            </BoxFR>
            <BoxFR justifyContent="space-between">
              <Typography>หัก ณ ที่จ่ายใบเสร็จลูกค้า</Typography>
              <TextField {...invDataProp("CusWhtPr", true)} />
            </BoxFR>
            <BoxFR justifyContent="space-between">
              <Typography>ยอดรวมใบแจ้งหนี้</Typography>
              <TextField {...invDataProp("Total", true)} />
            </BoxFR>
            <BoxFR justifyContent="space-between">
              <Typography>ยอดรวมหัก ณ ที่จ่าย</Typography>
              <TextField {...invDataProp("WhtPr", true)} />
            </BoxFR>
            <BoxFR justifyContent="space-between">
              <Typography>ยอดจ่าย</Typography>
              <TextField {...invDataProp("PayAmnt", true)} />
            </BoxFR>
            <FileUpload
              options={msData.serverData.PreText.InvoiceFiles || []}
              fileUploadData={fileUploadData}
              setFileUploadData={fn.setFileUploadData} />
            {
              selectedId > 0 && <ModAccName modDte={scInvData.ModDte} modAcc={scInvData.ModAcc} />
            }
          </BoxFC>
        </Paper>
      </DialogContent>
      <Popover
        open={popOverOpen}
        anchorEl={anchorEl}
        onClose={fn.handlePopOverClose}
        anchorOrigin={originBottomCenter}
        transformOrigin={originTopCenter}>
        <ReceiptPaper rcptData={selectedRow} sx={{ width: 500 }} />
      </Popover>

      <ExpenseJobOrderDialog
        state={{ dialogOpen: dialogExpOpen, selectedExpId, joData: selectedJOData }}
        fn={{
          setDialogOpen: fn.setDialogExpOpen,
          insertUpdateExpenseJobOrder: fn.handleExpenseDialogOK,
          deleteExpenseJobOrder: fn.deleteSubcontractExpense,
        }}
        getApiName={subcontractExpenseApiNm.getSubcontractExpense} />

      <AddExpenseTableDialog
        dialogOpen={dialogAddExpenseTableOpen}
        setDialogOpen={fn.setDialogAddExpenseTableOpen}
        onFinish={fn.onAddExpenseTableDialgoFinish}
        jobOrdIds={jobOrdIds}
        joData={selectedJOData}
        isFromSubcontract={true}
      />
      <InvoiceSearchDialog
        title="ดึงข้อมูลจากรถร่วม"
        setDialogOpen={fn.setDialogInvoiceSearchOpen}
        dialogOpen={dialogInvoiceSearchOpen}
        onFinish={fn.onInvoiceSearchDialogFinish} />

      <ExpenseMappingDialog
        dialogOpen={dialogMappingOpen}
        setDialogOpen={fn.setDialogMappingOpen}
        unmappedExpenses={mappingData?.unmappedExpenses || []}
        availableExpenses={mappingData?.availableExpenses || []}
        existingMappings={mappingData?.existingMappings || []}
        sourceSiteAbbr={mappingData?.sourceSiteAbbr || ''}
        onSave={fn.handleSaveMapping}
        onRemoveMapping={fn.handleRemoveMapping}
      />
      <SearchSubcontractExpenseDialog
        dialogOpen={dialogSearchOpen}
        setDialogOpen={fn.setDialogSearchOpen}
        setJobOrdTable={fn.setJobOrdTable}
      />

      <DialogFooter okText="บันทึกข้อมูล"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={
          selectedId === 0 ? () => validate(validation) && fn.insertSubcontractInvoiceWithExpense()
            : fn.updateSubcontractInvoice } />
    </Dialog>
  )
}

export default React.memo(SubcontractExpenseDialog)